import React from 'react';
import { ThumbsUp } from 'lucide-react';

export function GoodbyeView() {
  return (
    <div className="flex flex-col items-center justify-center h-[60vh] text-center space-y-6 animate-fadeIn">
      <div className="bg-indigo-900/50 p-6 rounded-full inline-block mb-2 relative z-10">
        <ThumbsUp className="h-16 w-16 text-indigo-400" />
      </div>
      <h2 className="text-3xl font-bold text-white">오늘도 고생 많으셨습니다! 👏</h2>
      <p className="text-slate-400">내일 또 만나요!</p>
    </div>
  );
}